import axios from "axios";

let _kingdomId;
let _worldId;

export async function login(kingdomId, worldId) {
    window.open("/apple/login.html");

    _kingdomId = kingdomId;
    _worldId = worldId;
}
export async function onlogin(params){
    console.log('params - ', params);

    let token = params.id_token;

    let payload = {token: token, authType: 'apple', fromKlay: {kingdomId: _kingdomId, worldId: _worldId}};

    let ret = await axios.post(
        `https://lok-api-live.leagueofkingdoms.com/api/auth/login`,
        {json: JSON.stringify(payload)}
      );

      console.log(ret);

      if (ret.data.result == false) {
          alert("이미 글로벌 서버에 있는 계정입니다. 다른 계정으로 시도해 주세요.")
      }
      else {
          location.reload();
      }

}
export async function logout() {
}